<style src="css/ask.css" scoped></style>
<template>
  <div style="padding-bottom: 0.98rem; padding-top: 1.4rem">
    <!--        <Swiper class="bannerBox" v-if="microBannerList.length > 0" :showIndicator='false' :autoPlay='true' interval="2500" duration="500">-->
    <!--            <Slide class="banner" @click="clickMe(item.picUrl)" :style="{background:`url(${EnvUrl+item.pic}) no-repeat center/cover`}" v-for="(item,index) in microBannerList" :key="index">-->
    <!--                &lt;!&ndash;&lt;!&ndash;//添加click事件&ndash;&gt;{{index}}&ndash;&gt;-->
    <!--            </Slide>-->
    <!--        </Swiper>-->
    <newsTopBox title="咨询"></newsTopBox>
    <div class="bannerBox"></div>
    <div class="titleBox">预约咨询</div>
    <div class="reducibleList">
      <div
        class="reducibleItem"
        :class="{ active: !bespeakAbled }"
        @click="changeBespeakAbled(0)"
      >
        全部咨询师
      </div>
      <div
        class="reducibleItem"
        :class="{ active: bespeakAbled }"
        @click="changeBespeakAbled(1)"
      >
        可预约咨询
      </div>
    </div>
    <div class="reducibleList">
      <div
        class="reducibleItem"
        :class="{ active: campusLocation == item }"
        v-for="item in doctorCampusList"
        @click="changeCampusLocation(item)"
      >
        {{ item }}
      </div>
    </div>
    <ul class="expertList">
      <li
        class="expertItem"
        v-for="item in doctorList"
        @click="to(`expertDetail?doctorId=${item.doctorId}`)"
      >
        <img class="avatar" :src="EnvUrl + item.doctorWorkPhoto" alt="" />
        <!--                <div class="avatar" :style="{background: `url(${EnvUrl}${item.doctorWorkPhoto}) no-repeat center/cover`}">-->
        <!--&lt;!&ndash;                    <div class="doctorHospital">{{item.doctorHospital}}</div>&ndash;&gt;-->
        <!--                </div>-->
        <div class="expertBox">
          <div class="nameBox">
            <div class="name">{{ item.doctorName }}</div>
            <!--                        <div class="expertBtn" v-if="item.status">咨询</div>-->
            <!--                        <div class="expertBtn active" v-else>休息</div>-->
            {{ item.doctorHospitalLevel }}
          </div>

          <div class="advantage">
            咨询师介绍：<span v-html="item.doctorProfile"></span>
          </div>

          <div class="lastBox">
            <ul class="expertTag">
              <li v-if="item.chatDoctorServe.video">
                {{ item.chatDoctorServe.video ? "视频咨询" : "" }}
                <!--                            服务人数{{item.honor}}-->
              </li>
              <li v-if="item.chatDoctorServe.telephone">
                {{ item.chatDoctorServe.telephone ? "电话疏导" : "" }}
              </li>
              <li v-if="item.chatDoctorServe.imageText">
                {{ item.chatDoctorServe.imageText ? "图文咨询" : "" }}
                <!--                            好评率{{item.starRate}}%-->
              </li>
              <li v-if="item.chatDoctorServe.offline">
                {{ item.chatDoctorServe.offline ? "线下咨询" : "" }}
              </li>
              <!--                            <li>服务人数{{item.honor}}</li>-->
              <!--                            <li>好评率{{item.starRate}}%</li>-->
            </ul>
            <!--                        <div class="priceBox">-->
            <!--                            ￥<span>4.9</span>起-->
            <!--                        </div>-->
          </div>
          <div
            class="addressBox"
            v-if="item.chatDoctorServe.remark && item.chatDoctorServe.offline"
          >
            线下地址：{{ item.chatDoctorServe.remark }}
          </div>
        </div>
      </li>
    </ul>
    <no-more-data :noMoreData="noMoreData"></no-more-data>
    <footerBox active="2"></footerBox>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      microBannerList: [],
      bespeakAbled: 0,
      doctorList: [],
      campusLocation: "全部",
      doctorCampusList: [],
      // companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
      companyId: "1001",
      pageIndex: 1,
      pageSize: 10,
      noMoreData: false,
      isLoading: false,
      count: 0,
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
    footerBox,
    newsTopBox,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    to(n) {
      this.$router.push(`/${n}`);
    },
    clickMe(n) {
      if (n) {
        location.href = n;
      }
    },
    async getScaleBannerList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroBannerList.json",
        {}
      );
      if (data.status === 0) {
        this.microBannerList = data.microBannerList;
      } else {
        alert(data.msg);
      }
    },
    changeBespeakAbled(n) {
      this.bespeakAbled = n;
      this.pageIndex = 1;
      this.doctorList = [];
      this.getDoctorList();
    },
    changeCampusLocation(n) {
      this.pageIndex = 1;
      this.doctorList = [];
      this.campusLocation = n;
      this.getDoctorList();
    },
    async getDoctorList() {
      let obj = {};
      obj.pageIndex = this.pageIndex;
      obj.pageSize = this.pageSize;
      obj.companyId = this.companyId;
      obj.bespeakAbled = this.bespeakAbled;
      obj.campusLocation =
        this.campusLocation == "全部" ? "" : this.campusLocation;
      let data = await getSources(
        "/bear-scale/api/chatDoctor/getDoctorList.json",
        obj
      );
      if (data.status === 0) {
        this.isLoading = false;
        this.count = data.count;
        this.doctorList = [...this.doctorList, ...data.doctorList];
        if (data.doctorCampusList.length > 0) {
          this.doctorCampusList = ["全部", ...data.doctorCampusList];
        }
        if (data.doctorList.length == 0) {
          this.noMoreData = true;
        } else {
          console.log(111111);
          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            console.log("显示");
            this.noMoreData = true;
          } else {
            console.log(2);
            this.noMoreData = false;
          }
        }
      } else {
        alert(data.msg);
      }
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getDoctorList();
        }
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    // this.getScaleBannerList()
    this.getDoctorList();
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ask.vue?83814638